export const colors = {
  primary: {
    headingsBody: '#166473',
    lightAltBody: '#87b1b9',
  },
  lightAccents: '#eadcd7',
  darkAccents: '#a47764',
  highlights: {
    callToAction: '#d16f53',
  },
  error: {
    light: '#f8d7da',
    dark: '#dc3545',
  },
  success: {
    light: '#d4edda',
    dark: '#28a745',
  },
  filters: {
    set1: {
      primary: "#7551FF",
      secondary: "#4318FF"
    },
    set2: {
      primary: "#00B074",
      secondary: "#00B074"
    }
  }
}; 